module.exports = __webpack_public_path__ + "img/bird.6d7b9ffc.svg";